import { createContext } from 'react'
import { DeleteConfirmOpen } from './useDeleteConfirmProvider'

export default createContext({
  open: (props: DeleteConfirmOpen) => null,
})
